/**
 * Apre in una nuova scheda un URL presigned che si ottiene in modo asincrono.
 *
 * Safari su iOS consente `window.open()` solo in modo sincrono nello stesso tick del
 * gesto dell'utente: se la scheda si aprisse dopo l'attesa del link, il blocco popup la
 * scarterebbe in silenzio (DEV-269). Si apre quindi subito una scheda vuota e la si punta
 * al link reale appena arriva; in caso di errore la scheda vuota si chiude.
 */
export async function openPresignedUrlInNewTab(fetchUrl: () => Promise<string>): Promise<void> {
  const tab = window.open('', '_blank');
  if (tab) {
    // Tiene l'handle sincrono richiesto da Safari senza esporre la finestra dell'app
    // all'origine del documento.
    tab.opener = null;
  }
  try {
    const url = await fetchUrl();
    if (tab) {
      tab.location.href = url;
    } else {
      // Il blocco popup ha impedito anche la scheda pre-aperta: ultimo tentativo.
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  } catch (error) {
    tab?.close();
    throw error;
  }
}
